import React from 'react'
import { Link } from 'react-router-dom';
import WalletConnection from "../../WalletConnection"
function Nav() {
  return (
    <div>
      <nav className="navbar navbar-expand-lg " style={{backgroundColor:"transparent"}}>
        <div className="container-fluid">
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon" />
          </button>

          <div className="collapse navbar-collapse" id="navbarSupportedContent">
          

            {/* Center Link */}
            <ul className="navbar-nav mx-auto gap-3">
            <li className="nav-item">
                <Link className="nav-link active text-light" aria-current="page" to="/">
                Plan Bee Gamefi
                </Link>
              </li>
              <li className="nav-item">
                <a className="nav-link text-light" href="/about">
                About Us
                </a>
              </li>
              <li className="nav-item">
                <Link className="nav-link text-light" to="/info">
                My Info
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link text-light" to="/FAQ">
                FAQ
                </Link>
              </li>
            </ul>

            {/* Right Side Button */}
            <div className="d-flex">
            <button className="connect">
  <span><WalletConnection/></span>
</button>

            </div>
          </div>
        </div>
      </nav>
    </div>
  );
}

export default Nav;
